module.exports = __webpack_public_path__ + "img/pic_18.dc017a10.jpg";